import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import React from 'react';
import { getAcademicTitle } from '../../../../../Interfaces/IAcademicTitle';
import { IConfig } from '../../../../../Interfaces/IConfig';
import { DialogLegalTransactionTypeMapping } from '../../../../../Interfaces/IDialogLegalTransactionTypeMapping';
import { ILegalClient } from '../../../../../Interfaces/ILegalClient';
import { ILegalTransactionRelationship } from '../../../../../Interfaces/ILegalTransactionRelationship/ILegalTransactionRelationship';
import { IGeneralRelationshipData } from '../../../../../Interfaces/ILegalTransactionRelationship/Relationships/General/ILegalTransactionRelationshipGeneralData';
import { checkString } from '../../../../core/standardFunctions';
import { CustomeTextField } from '../../../../generic/CustomeTextField';
import { SendLegalClient } from '../../../../LegalClient/SendLegalClient';
import { useLegalClientStore } from '../../generic/legalClientStore';

interface IGeneralSummaryProps {
  configObject: IConfig;
  generalRelationshipData: IGeneralRelationshipData;
  setGeneralRelationshipData: React.Dispatch<
    React.SetStateAction<IGeneralRelationshipData>
  >;
  legalClientArray: ILegalClient[];
  setLegalClientArray: React.Dispatch<React.SetStateAction<ILegalClient[]>>;
  relationshipArray: ILegalTransactionRelationship[];
  setRelationshipArray: React.Dispatch<
    React.SetStateAction<ILegalTransactionRelationship[]>
  >;
  handleNext: () => void;
  handleBack: () => void;
}

export const GeneralSummary: React.FC<IGeneralSummaryProps> = ({
  configObject,
  generalRelationshipData,
  setGeneralRelationshipData,
  relationshipArray,
  setRelationshipArray,
  handleNext,
  handleBack,
}) => {
  const [legalClientArray] = useLegalClientStore(state => [
    state.legalClientArray,
  ]);

  return (
    <>
      <Typography variant='h4' sx={{ mb: 3 }}>
        Abschluss
      </Typography>

      <Typography>
        Vielen Dank für die Eingabe Ihrer Daten. Bitte überprüfen Sie Ihre Daten
        nun noch einmal in der Übersicht. Wenn alles korrekt ist, senden Sie
        Ihre Daten bitte ab.
      </Typography>

      <Box sx={{ mt: 5 }} />
      <Typography variant='h6' sx={{ mb: 3 }}>
        Abschließende Angaben zu Ihrem Anliegen
      </Typography>
      <CustomeTextField
        attr='notes'
        label='Anmerkungen'
        object={generalRelationshipData}
        setObject={setGeneralRelationshipData}
        type='string'
        rows={5}
      />
      <Box sx={{ mt: 5 }} />
      <Typography variant='h6' sx={{ mb: 3 }}>
        Zusammenfassung
      </Typography>

      <Typography variant='h6' sx={{ mb: 3 }}>
        Beteiligte
      </Typography>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell width={20}>Nr.</TableCell>
            <TableCell width={120}>Titel</TableCell>
            <TableCell>Name</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {legalClientArray.map((legalClient, idx) => (
            <TableRow>
              <TableCell>{idx + 1}</TableCell>
              <TableCell>
                {checkString(getAcademicTitle(legalClient.idAcademicTitle))}
              </TableCell>
              <TableCell>
                {legalClient.FirstName} {legalClient.LastName}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <SendLegalClient
        configObject={configObject}
        idLegalTransactionType={DialogLegalTransactionTypeMapping.General}
        relationshipArray={relationshipArray}
        setRelationshipArray={setRelationshipArray}
        handleBack={handleBack}
        handleNext={handleNext}
      />
    </>
  );
};
